import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import icons from '../assets/icons'

type Props = {
  content: string
  fullScreen: boolean
}

const ContentText: React.FC<Props> = ({ content, fullScreen }: Props) => {
  const { t } = useTranslation()
  const ref = useRef<HTMLParagraphElement>(null)
  const [showMore, setShowMore] = useState(true)
  const [height, setHeight] = useState<number | null>(null)

  useEffect(() => {
    setShowMore(false)
    setHeight(null)
  }, [content])

  useEffect(() => {
    if (ref?.current) {
      ref.current.classList.remove('hidetext', 'showtext')

      const fullHeight = ref.current.scrollHeight

      ref.current.classList.add(!showMore && height ? 'hidetext' : 'showtext')

      setHeight(fullHeight)
    }
  }, [content, showMore, height])

  const onShowMore = useCallback(() => {
    setShowMore(true)
  }, [])

  if (fullScreen) {
    return null
  }

  return (
    <>
      <div
        ref={ref}
        className={`text text--size14 text--lineHeight19 modal--content--container--text ${
          !showMore && height ? 'hidetext' : 'showtext'
        }`}
        dangerouslySetInnerHTML={{ __html: content }}
      />

      {!showMore && height && height > 114 && (
        <div className='modal--content--more' onClick={onShowMore}>
          <p className='text text--nomargin text--size14 text--center'>{t('showMore')}</p>
          <img src={icons.plus} alt='' />
        </div>
      )}
    </>
  )
}

export default ContentText
